import { useMemo } from "react";
import dayjs from "../../../../../configs/dayjs";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";

export const useFormatHistoryData = (data: any, granularity: number) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const chardData = useMemo(() => {
    return data && data.length > 0
      ? data[0].kpiValues
          .map((item: any) => ({
            xAxis: dayjs(item.createdAt).format(xAxisFormat),
            value: item.value,
            tooltipHeader: dayjs(item.createdAt).format(tooltipFormat),
            toolTipName: data[0].code.split(".")[0],
          }))
          .reverse()
      : [];
  }, [data, xAxisFormat, tooltipFormat]);

  return { chardData };
};
